import React from 'react'
import { Helmet } from 'react-helmet'
import { buildPageSeo, SITE_NAME, SITE_NAME_KO } from '../../constants/siteSeo'

const GOOGLE_SITE_VERIFICATION = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION
const NAVER_SITE_VERIFICATION = process.env.REACT_APP_NAVER_SITE_VERIFICATION

/**
 * Google·네이버 등 검색 포털용 통합 메타 태그
 * @param {{
 *   seo?: ReturnType<typeof buildPageSeo>,
 *   pageLabel?: string,
 *   title?: string,
 *   description?: string,
 *   keywords?: string | string[],
 *   pathname?: string,
 *   image?: string,
 *   noindex?: boolean,
 *   isHome?: boolean,
 * }} props
 */
const PageSeo = ({ seo: prebuilt, pathname: pathnameProp, ...rest }) => {
    const seo = prebuilt ?? buildPageSeo({ pathname: pathnameProp, ...rest })
    const robots = seo.noindex ? 'noindex, nofollow' : 'index, follow'

    return (
        <Helmet>
            <html lang="ko" />
            <title>{seo.title}</title>
            <meta name="description" content={seo.description} />
            <meta name="keywords" content={seo.keywords} />
            <meta name="robots" content={robots} />
            <meta name="author" content={SITE_NAME_KO} />
            <meta name="publisher" content={SITE_NAME} />

            <link rel="canonical" href={seo.canonical} />

            <meta property="og:locale" content="ko_KR" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={seo.title} />
            <meta property="og:description" content={seo.description} />
            <meta property="og:url" content={seo.ogUrl} />
            <meta property="og:image" content={seo.ogImage} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.ogImage} />

            {GOOGLE_SITE_VERIFICATION ? (
                <meta name="google-site-verification" content={GOOGLE_SITE_VERIFICATION} />
            ) : null}
            {NAVER_SITE_VERIFICATION ? (
                <meta name="naver-site-verification" content={NAVER_SITE_VERIFICATION} />
            ) : null}

            {seo.isHome ? (
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Organization',
                        name: SITE_NAME,
                        alternateName: SITE_NAME_KO,
                        url: seo.canonical,
                        logo: seo.ogImage,
                        description: seo.description,
                    })}
                </script>
            ) : null}
        </Helmet>
    )
}

export default PageSeo
